import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3f37a526"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "impact" };
import { onMounted, reactive } from 'vue';
import AttributedRevenue from '@/features/OtoBrandImpact/components/AttributedRevenue/AttributedRevenue.vue';
import InfluencedRevenue from '@/features/OtoBrandImpact/components/InfluencedRevenue/InfluencedRevenue.vue';
import WelcomeSkeleton from '@/components/welcome/WelcomeSkeleton.vue';
import { fetchOtoImpactIndicators } from '@/features/OtoBrandImpact/data/fetchOtoImpactIndicators';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ImpactIndicator',
    setup(__props) {
        const state = reactive({
            impactValues: {},
            loading: false,
        });
        async function otoImpactValuesRequest() {
            state.loading = true;
            const response = await fetchOtoImpactIndicators();
            state.impactValues = response?.data;
            state.loading = false;
        }
        onMounted(() => otoImpactValuesRequest());
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (state.loading)
                    ? (_openBlock(), _createBlock(WelcomeSkeleton, { key: 0 }))
                    : _createCommentVNode("", true),
                (!state.loading && state.impactValues)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(AttributedRevenue, {
                            "impact-values": state.impactValues
                        }, null, 8, ["impact-values"]),
                        _createVNode(InfluencedRevenue, {
                            "impact-values": state.impactValues
                        }, null, 8, ["impact-values"])
                    ], 64))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
